module.exports = __webpack_public_path__ + "media/images/shower@2x-6097728bae5fcea26470c9b31e41fd5d.jpg";